import { Container, Sprite, Texture } from 'pixi.js';
import { GAME_OBJECT_POOL } from '../../GameConstants';

export class HintArrowView extends Container {
  private static readonly arrowAnimateMaxY = 10;

  private readonly arrow: Sprite;

  public static getFreeInstance(): HintArrowView {
    return GAME_OBJECT_POOL.getObject(HintArrowView) ?? new HintArrowView();
  }

  public static returnInstance(instance: HintArrowView): void {
    instance.parent?.removeChild(instance);
    instance.reset();
    GAME_OBJECT_POOL.addObject(HintArrowView, instance);
  }

  constructor() {
    super();

    this.arrow = new Sprite(Texture.from('hint_arrow')).props({
      parent: this,
      scale: { x: 1, y: -1 },
      anchor: { x: 0.5, y: 0 },
    });

    this.updateOffset(0);
    this.reset();
  }

  public reset(): this {
    this.removeTweens();
    this.props({
      x: 0,
      y: 0,
      alpha: 0,
      scale: 1,
    });
    this.arrow.props({
      x: 0,
      y: 0,
    });
    return this;
  }

  public updateOffset(offsetRatio: number): void {
    this.arrow.y = offsetRatio * HintArrowView.arrowAnimateMaxY;
  }

  public show(): void {
    this.removeTweens();
    this.tweenTo({ alpha: 1 }, 333, 'quadOut', true);
  }

  public async hide(): Promise<void> {
    this.removeTweens();
    await this.tweenTo({ alpha: 0 }, 333, 'quadOut', true).asyncOnComplete();
  }
}
